// this is an inlined version of vue2-scrollspy which has been updated for Vue 3
// see https://github.com/ibufu/vue2-scrollspy/blob/master/src/animate.js

import TWEEN from '@tweenjs/tween.js';

// eslint-disable-next-line func-names
const requestAnimationFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    // eslint-disable-next-line func-names
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

function animate() {
  if (TWEEN.update()) {
    requestAnimationFrame(animate);
  }
}

requestAnimationFrame(animate);

export const { Easing } = TWEEN;

export function scrollWithAnimation(scrollEl, current, target, time, easing) {
  new TWEEN.Tween({ postion: current })
    .to({ postion: target }, time)
    .easing(easing)
    // eslint-disable-next-line func-names
    .onUpdate(function (val) {
      // eslint-disable-next-line no-param-reassign
      scrollEl.scrollTop = val.postion;
    })
    .start();

  animate();
}
